import styled from 'styled-components';

import variables from '../../../styles/variables';
import Image from '../../UI/Image/Image';

import prevArrowBlack from '../../../images/back-arrow-left-black.svg';
import nextArrowBlack from '../../../images/back-arrow-right-black.svg';

// Image gallery styling
export const ImageGallery = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  max-width: 600px;
  @media screen and (min-width: 640px) and (max-width: 768px) {
    width: 75%;
  }
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  @media screen and (max-width: 415px) {
    display: none;
  }
`;

export const PrimaryImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  @media screen and (max-width: 415px) {
    display: none;
  }
`;

export const PrimaryImage = styled(Image)`
  max-height: 605px;
  margin-top: 34px;
  width: 300px;
  @media screen and (min-width: 415px) and (max-width: 768px) {
    max-height: 505px;
    margin-top: 24px;
    width: 250px;
  }
`;

export const ImageWrap = styled.button`
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  border: ${({ selectedImg, image }) => selectedImg === image ? '1px solid #333333' : '1px solid #979797'};
  &:last-child {
    margin-bottom: 0;
  }
  background: transparent;
`;

export const SecondaryImages = styled(Image)`
  margin: 10px;
  max-height: 105px;
  width: 52px;
  @media screen and (min-width: 769px) {
    max-height: 135px;
    width: 65px;
  }
`;

// Mobile carousel styling
export const CarouselWrapper = styled.div`
  display: block;
  width: 100%;
  @media screen and (min-width: 767px) {
    display: none;
  }
  li.slider-slide {
    display: inline-flex !important;
    align-items: center;
  }

  .swiper {
    height: 100%;
    overflow: hidden;

    @media screen and (max-width: 1024px) {
      padding: 0 0 3rem;
    }

    .swiper-container {
      height: auto;
    }

    .swiper-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
      margin-bottom: 3rem;

      .swiper-slide {
        height: auto;
        font-size: 18px;
        display: flex;
        width: 100% !important;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        align-self: stretch;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      height: 24px;
      width: 24px;
      border-radius: 12px;
      border: 2px solid ${variables.colorWhite};
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 30%);
      cursor: pointer;
      z-index: 11;
      transition:
        border 400ms ease,
        opacity 400ms ease;

      &.swiper-button-disabled {
        opacity: 0;
        visibility: hidden;
      }

      &:after {
        content: none;
      }

      &:hover,
      &:focus {
        border: 2px solid ${variables.colorGrey};
      }
    }

    .swiper-button-next {
      background-image: url(${nextArrowBlack});
      right: 2px;

      @media screen and (max-width: 640px) {
        right: 2px;
        top: auto;
        bottom: 10px;
      }
    }

    .swiper-button-prev {
      background-image: url(${prevArrowBlack});

      @media screen and (max-width: 640px) {
        left: 2px;
        top: auto;
        bottom: 10px;
      }
    }

    .swiper-pagination {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      bottom: 16px;
      left: 0;
      right: 0;
      width: calc(100% - 60px);
    }

    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal {
      &.swiper-pagination-bullets {
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          margin: 0 8px;
        }
      }
    }

    .swiper-pagination-bullet-active {
      background: ${variables.colorRed};
    }
  }
`;

export const CarouselImage = styled(Image)`
  width: 185px !important;
  margin: 0 auto;

  @media screen and (max-width: 480px) {
    width: 150px !important;
  }
`;

export const DesktopWrapper = styled.div`
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
    width: 100%;
  } 
`;
